module.exports = __webpack_public_path__ + "img/32.319fab39.png";